import { useBucket } from '@mc/experiments-react'
import { trackExperimentViewed } from '@mc/track-event'

// Growthbook experiment: https://app.growthbook.io/features/com-1842-price-change-fe
export const PRICE_CHANGE_EXPERIMENT_FLAG = 'com-1842-price-change-fe'
export const PRICE_CHANGE_PARAM_NAME = 'experiment'
export const PRICE_CHANGE_PARAM_VALUE = 'price-ab'
export const PRICE_CHANGE_VARIANT_2_PARAM_NAME = 'duration_unit'
export const PRICE_CHANGE_VARIANT_2_PARAM_VALUE = 'year'

export const trackPriceChangeExperimentViewed = () => {
  trackExperimentViewed(
    PRICE_CHANGE_EXPERIMENT_FLAG,
    {},
    { trackUserLeap: true },
  )
}

export const usePriceChangeExperiment = () => {
  const bucket = useBucket(PRICE_CHANGE_EXPERIMENT_FLAG)
  return bucket
}
